window.addEventListener('load', event => {
    const industryAwardsPanel = document.getElementById('industryAwardsPanel');

    if (industryAwardsPanel) {
        const awardYearSelector = industryAwardsPanel.querySelector('[data-award-year-selector]');
        const awardDataContainers = industryAwardsPanel.querySelectorAll('[data-award-year]');

        if (awardYearSelector) {
            awardYearSelector.addEventListener('change', function() {
                const selectedYear = awardYearSelector.value;
                industryAwardsPanel.setAttribute('data-showing-award-year', selectedYear);

                awardDataContainers.forEach(awardDataContainer => {
                    if (awardDataContainer.dataset.awardYear === selectedYear) {
                        awardDataContainer.dataset.active = 'true';
                    } else {
                        awardDataContainer.dataset.active = 'false';
                    }
                });
            });
        }
    }
});